<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-cell title="项目名称：" :value="headInfo.projectName"></hi-cell>
    <hi-cell title="项目编码：" :value="headInfo.pcInfoId"></hi-cell>
    <hi-cell title="项目描述：" :value="headInfo.projectDesc"></hi-cell>
    <hi-cell title="采购组织：" :value="headInfo.purorgName"></hi-cell>
    <hi-cell title="采购组长：" :value="headInfo.purchaseHead"></hi-cell>
    <hi-cell title="供货品类：" :value="headInfo.catgName"></hi-cell>
    <hi-cell title="币种：" :value="headInfo.currencyName"></hi-cell>
    <hi-cell title="采购定价类型：" :value="headInfo.purCategory" :options="purCategoryOptions"></hi-cell>
    <hi-cell title="询比价类型：" :value="headInfo.pcType" :options="pcTypeOptions"></hi-cell>
    <hi-cell title="报价截止日期：" :value="headInfo.quoteEndDate"></hi-cell>
    <hi-cell title="报价类型：" :value="headInfo.quoteType" :options="quoteTypeOptions"></hi-cell>
    <hi-cell title="价格是否含税：" :value="headInfo.taxHaveNot" :options="taxHaveNotOptions"></hi-cell>
    <hi-cell title="人民币兑美元汇率取价日：" :value="headInfo.exchangeRateDate"></hi-cell>
    <hi-cell title="人民币兑美元汇率维护：" :value="headInfo.exchangeRate"></hi-cell>
    <hi-cell title="计划交货时间(天)：" :value="headInfo.planDeliveryTime"></hi-cell>
    <hi-cell title="公告署名公司：" :value="headInfo.contactCompanyName"></hi-cell>
    <hi-cell title="是否选择项目评定人员：" :value="headInfo.needJudgePersion" :options="needJudgePersionOptions">
    </hi-cell>
    <hi-cell title="阶梯报价：" :value="headInfo.tieredPrice" :options="tieredPriceOptions"></hi-cell>
    <hi-cell title="预估价是否开放给供方：" :value="headInfo.openEvaluatePrice" :options="needJudgePersionOptions">
    </hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    purCategoryOptions() {
      return this.$store.getters.dicts.pur_category
    },
    pcTypeOptions() {
      return this.$store.getters.dicts.price_comp_type
    },
    quoteTypeOptions() {
      return this.$store.getters.dicts.quote_type
    },
    taxHaveNotOptions() {
      return this.$store.getters.dicts.yes_no
    },
    needJudgePersionOptions() {
      return this.$store.getters.dicts.yes_no
    },
    tieredPriceOptions() {
      return this.$store.getters.dicts.tiered_price
    }
  }
}
</script>
